import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";

export const Template = ({
    variant,
    text,
    buttonLabel,
    primaryButtonLabel,
}) => html`
    <ux-iws-sf-cta-footer variant=${ifDefined(variant)}>
        <p slot="text">${text}</p>
        <div slot="cta">
            ${primaryButtonLabel &&
            html`
                <ux-button
                    variant="primary"
                    href="#"
                    aria-label="${primaryButtonLabel}"
                >
                    ${primaryButtonLabel}
                </ux-button>
            `}
            ${buttonLabel &&
            html`
                <ux-button href="#" aria-label="${buttonLabel}">
                    ${buttonLabel}
                </ux-button>
            `}
        </div>
    </ux-iws-sf-cta-footer>
`;
